import axios from '../../helpers/interceptors';

import {
    TEST,
    SET_MOBILE_NAV_STATUS,
    GET_USER_DATA_STARTED,
    GET_USER_DATA_SUCCESS,
    GET_USER_DATA_FAILURE,
    LOGOUT_STARTED,
    LOGOUT_SUCCESS,
    LOGOUT_FAILURE,
    GET_WALLETS_STARTED,
    GET_WALLETS_SUCCESS,
    GET_WALLETS_FAILURE,
    SET_CABINET_WALLET_RECEIVE_MODAL_STATUS,
    SET_CABINET_WALLET_SEND_MODAL_STATUS,
    GET_RECEIVE_CURRENCY_STARTED,
    GET_RECEIVE_CURRENCY_SUCCESS,
    GET_RECEIVE_CURRENCY_FAILURE,
    GET_RECEIVE_NETWORK_STARTED,
    GET_RECEIVE_NETWORK_SUCCESS,
    GET_RECEIVE_NETWORK_FAILURE,
    GET_RECEIVE_ASSET_STARTED,
    GET_RECEIVE_ASSET_SUCCESS,
    GET_RECEIVE_ASSET_FAILURE,
    GET_SEND_CURRENCY_STARTED,
    GET_SEND_CURRENCY_SUCCESS,
    GET_SEND_CURRENCY_FAILURE,
    GET_SEND_NETWORK_STARTED,
    GET_SEND_NETWORK_SUCCESS,
    GET_SEND_NETWORK_FAILURE,
    GET_SEND_ASSET_STARTED,
    GET_SEND_ASSET_SUCCESS,
    GET_SEND_ASSET_FAILURE,
    GET_SEND_FEE_STARTED,
    GET_SEND_FEE_SUCCESS,
    GET_SEND_FEE_FAILURE,
    GET_WALLET_HISTORY_STARTED,
    GET_WALLET_HISTORY_SUCCESS,
    GET_WALLET_HISTORY_FAILURE,
    GET_MARKET_CHARTS_STARTED,
    GET_MARKET_CHARTS_SUCCESS,
    GET_MARKET_CHARTS_FAILURE,
    GET_PARTNERS_MAIN_DATA_STARTED,
    GET_PARTNERS_MAIN_DATA_SUCCESS,
    GET_PARTNERS_MAIN_DATA_FAILURE,
    GET_ALL_PARTNERS_STARTED,
    GET_ALL_PARTNERS_SUCCESS,
    GET_ALL_PARTNERS_FAILURE,
    EXCHANGE_POINTS_STARTED,
    EXCHANGE_POINTS_SUCCESS,
    EXCHANGE_POINTS_FAILURE,
    GET_PARTNERS_CARD_STARTED,
    GET_PARTNERS_CARD_SUCCESS,
    GET_PARTNERS_CARD_FAILURE,
    SET_CABINET_PARTNERS_CARD_EDIT_MODAL_STATUS,
    SET_PARTNERS_CARD_SETTINGS_STARTED,
    SET_PARTNERS_CARD_SETTINGS_SUCCESS,
    SET_PARTNERS_CARD_SETTINGS_FAILURE,
    SET_CABINET_WALLET_SUBSCRIBE_MODAL_STATUS,
    GET_SUBSCRIBE_STARTED,
    GET_SUBSCRIBE_SUCCESS,
    GET_SUBSCRIBE_FAILURE,
    SET_SUBSCRIBE_STATUS,
    SET_CABINET_PARTNERS_POINTS_HISTORY_MODAL_STATUS,
    SET_CABINET_PARTNERS_CONVERT_POINTS_HISTORY_MODAL_STATUS,
    SET_CABINET_PROFILE_PERSONAL_INFORMATION_EDIT_MODAL_STATUS,
    SET_PROFILE_PERSONAL_INFORMATION_STARTED,
    SET_PROFILE_PERSONAL_INFORMATION_SUCCESS,
    SET_PROFILE_PERSONAL_INFORMATION_FAILURE,
    GET_PROFILE_MAIN_DATA_STARTED,
    GET_PROFILE_MAIN_DATA_SUCCESS,
    GET_PROFILE_MAIN_DATA_FAILURE,
    SET_CABINET_PROFILE_CHANGE_PASSWORD_MODAL_STATUS,
    PROFILE_CHANGE_PASSWORD_STARTED,
    PROFILE_CHANGE_PASSWORD_SUCCESS,
    PROFILE_CHANGE_PASSWORD_FAILURE,
    SET_CABINET_PROFILE_TWO_FACTOR_MODAL_STATUS,
    GET_PROFILE_OPTION_2FA_STARTED,
    GET_PROFILE_OPTION_2FA_SUCCESS,
    GET_PROFILE_OPTION_2FA_FAILURE,
    SET_PROFILE_OPTION_2FA_STARTED,
    SET_PROFILE_OPTION_2FA_SUCCESS,
    SET_PROFILE_OPTION_2FA_FAILURE,
    SET_GOOGLE_CODE_2FA_STARTED,
    SET_GOOGLE_CODE_2FA_SUCCESS,
    SET_GOOGLE_CODE_2FA_FAILURE,
    SET_2FA_SETTINGS_STARTED,
    SET_2FA_SETTINGS_SUCCESS,
    SET_2FA_SETTINGS_FAILURE,
    SET_CABINET_DEPOSIT_OPEN_MODAL_STATUS,
    GET_DEPOSIT_ALL_STARTED,
    GET_DEPOSIT_ALL_SUCCESS,
    GET_DEPOSIT_ALL_FAILURE,
    GET_DEPOSIT_CURRENCY_STARTED,
    GET_DEPOSIT_CURRENCY_SUCCESS,
    GET_DEPOSIT_CURRENCY_FAILURE,
    GET_DEPOSIT_NETWORK_STARTED,
    GET_DEPOSIT_NETWORK_SUCCESS,
    GET_DEPOSIT_NETWORK_FAILURE,
    GET_DEPOSIT_ASSET_STARTED,
    GET_DEPOSIT_ASSET_SUCCESS,
    GET_DEPOSIT_ASSET_FAILURE,
    SET_CABINET_PROFILE_DISABLE_2FA_MODAL_STATUS,
    DISABLE_2FA_STARTED,
    DISABLE_2FA_SUCCESS,
    DISABLE_2FA_FAILURE,
    GET_DEPOSIT_FEE_STARTED,
    GET_DEPOSIT_FEE_SUCCESS,
    GET_DEPOSIT_FEE_FAILURE,
    OPEN_DEPOSIT_STARTED,
    OPEN_DEPOSIT_SUCCESS,
    OPEN_DEPOSIT_FAILURE,
    GET_TWO_FACTOR_OPTIONS_STARTED,
    GET_TWO_FACTOR_OPTIONS_SUCCESS,
    GET_TWO_FACTOR_OPTIONS_FAILURE,
    SEND_CRYPTO_STARTED,
    SEND_CRYPTO_SUCCESS,
    SEND_CRYPTO_FAILURE,
    UPDATE_USER_AVATAR_STARTED,
    UPDATE_USER_AVATAR_SUCCESS,
    UPDATE_USER_AVATAR_FAILURE,
    GET_PARTNERS_CONVERT_HISTORY_STARTED,
    GET_PARTNERS_CONVERT_HISTORY_SUCCESS,
    GET_PARTNERS_CONVERT_HISTORY_FAILURE,
    HIDE_BALANCE_STARTED,
    HIDE_BALANCE_SUCCESS,
    HIDE_BALANCE_FAILURE,
    REFRESH_WALLET_HISTORY
} from "./types";

import {api} from "../../api";
import {setAuthorizationStatus, setTokenStatus} from "../main/action";

// import {toast} from "react-toastify";
const host = api.host;

const headWT = ()=>{
    const token = localStorage.getItem('b-token');
    return {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }
}
//
// const headWTFD = ()=>{
//     const token = localStorage.getItem('oli-token');
//     return {
//         headers: {
//             'Authorization': `Bearer ${token}`,
//             'Accept': 'application/json'
//         }
//     }
// }

export const test = data => ({
    type: TEST,
    payload: data
});

export const setMobileNavStatus = status => ({
    type: SET_MOBILE_NAV_STATUS,
    payload: status
});

export const setSubscribeStatus = status => ({
    type: SET_SUBSCRIBE_STATUS,
    payload: status
});

export const refreshWalletHistory = () => ({
    type: REFRESH_WALLET_HISTORY,
});

export const getUserData = () => {
    let url = host + api.cabinet.userData;


    return dispatch => {
        dispatch(getUserDataStarted());
        axios.get(url, headWT())
            .then(res => {
                const userData = res.data.response;
                const isEmailVerified = userData?.email_verified === true;

                localStorage.setItem('b-subscribe', userData?.subscription_status);
                dispatch(setSubscribeStatus(userData?.subscription_status))

                dispatch(getUserDataSuccess(userData));

                if (isEmailVerified) {
                    localStorage.setItem('b-auth-status', 'true');
                    dispatch(setAuthorizationStatus(true));
                } else {
                    localStorage.removeItem('b-auth-status');
                    dispatch(setAuthorizationStatus(false));
                }
            })
            .catch(err => {
                dispatch(getUserDataFailure(err));
            });
    };
};

const getUserDataStarted = () => ({
    type: GET_USER_DATA_STARTED
});

export const getUserDataSuccess = serverReport => ({
    type: GET_USER_DATA_SUCCESS,
    payload: serverReport
});

export const getUserDataFailure = error => ({
    type: GET_USER_DATA_FAILURE,
    payload: error
});


export const logout = () => {
    let url = host + api.cabinet.logout;

    return dispatch => {
        dispatch(logoutStarted());
        axios.post(url, null, headWT())
            .then(res => {
                dispatch(logoutSuccess(res));
                localStorage.removeItem('b-token');
                localStorage.removeItem('b-auth-status');
                dispatch(setTokenStatus(false));
                dispatch(setAuthorizationStatus(false));
                // dispatch(clearCabinetState());
            })
            .catch(err => {
                localStorage.removeItem('b-token');
                localStorage.removeItem('b-auth-status');
                dispatch(setTokenStatus(false));
                dispatch(setAuthorizationStatus(false));
                dispatch(logoutFailure(err));
                // dispatch(clearCabinetState());
            });
    };
};

const logoutStarted = () => ({
    type: LOGOUT_STARTED
});

export const logoutSuccess = serverReport => ({
    type: LOGOUT_SUCCESS,
    payload: serverReport
});

export const logoutFailure = error => ({
    type: LOGOUT_FAILURE,
    payload: error
});


export const getWallets = () => {
    let url = host + api.cabinet.wallets;


    return dispatch => {
        dispatch(getWalletsStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getWalletsSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getWalletsFailure(err));
            });
    };
};

const getWalletsStarted = () => ({
    type: GET_WALLETS_STARTED
});

export const getWalletsSuccess = serverReport => ({
    type: GET_WALLETS_SUCCESS,
    payload: serverReport
});

export const getWalletsFailure = error => ({
    type: GET_WALLETS_FAILURE,
    payload: error
});

export const setCabinetWalletReceiveModalStatus = status => ({
    type: SET_CABINET_WALLET_RECEIVE_MODAL_STATUS,
    payload: status
});

export const setCabinetWalletSendModalStatus = status => ({
    type: SET_CABINET_WALLET_SEND_MODAL_STATUS,
    payload: status
});


export const getReceiveCurrency = () => {
    let url = host + api.cabinet.getCurrency;


    return dispatch => {
        dispatch(getReceiveCurrencyStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getReceiveCurrencySuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getReceiveCurrencyFailure(err));
            });
    };
};

const getReceiveCurrencyStarted = () => ({
    type: GET_RECEIVE_CURRENCY_STARTED
});

export const getReceiveCurrencySuccess = serverReport => ({
    type: GET_RECEIVE_CURRENCY_SUCCESS,
    payload: serverReport
});

export const getReceiveCurrencyFailure = error => ({
    type: GET_RECEIVE_CURRENCY_FAILURE,
    payload: error
});


export const getSendCurrency = () => {
    let url = host + api.cabinet.getCurrency;


    return dispatch => {
        dispatch(getSendCurrencyStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getSendCurrencySuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getSendCurrencyFailure(err));
            });
    };
};

const getSendCurrencyStarted = () => ({
    type: GET_SEND_CURRENCY_STARTED
});

export const getSendCurrencySuccess = serverReport => ({
    type: GET_SEND_CURRENCY_SUCCESS,
    payload: serverReport
});

export const getSendCurrencyFailure = error => ({
    type: GET_SEND_CURRENCY_FAILURE,
    payload: error
});


export const getReceiveNetwork = (id) => {
    let url = host + api.cabinet.getCurrency + `/${id}/networks`;


    return dispatch => {
        dispatch(getReceiveNetworkStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getReceiveNetworkSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getReceiveNetworkFailure(err));
            });
    };
};

const getReceiveNetworkStarted = () => ({
    type: GET_RECEIVE_NETWORK_STARTED
});

export const getReceiveNetworkSuccess = serverReport => ({
    type: GET_RECEIVE_NETWORK_SUCCESS,
    payload: serverReport
});

export const getReceiveNetworkFailure = error => ({
    type: GET_RECEIVE_NETWORK_FAILURE,
    payload: error
});


export const getSendNetwork = (id) => {
    let url = host + api.cabinet.getCurrency + `/${id}/networks`;


    return dispatch => {
        dispatch(getSendNetworkStarted(id));
        axios.get(url, headWT())
            .then(res => {
                dispatch(getSendNetworkSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getSendNetworkFailure(err));
            });
    };
};

const getSendNetworkStarted = currencyId => ({
    type: GET_SEND_NETWORK_STARTED,
    payload: currencyId
});

export const getSendNetworkSuccess = serverReport => ({
    type: GET_SEND_NETWORK_SUCCESS,
    payload: serverReport
});

export const getSendNetworkFailure = error => ({
    type: GET_SEND_NETWORK_FAILURE,
    payload: error
});


export const getReceiveAsset = (currency_id, network_id) => {
    let url = host + api.cabinet.getReceiveAsset + `/?currency_id=${currency_id}&network_id=${network_id}`;


    return dispatch => {
        dispatch(getReceiveAssetStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getReceiveAssetSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getReceiveAssetFailure(err));
            });
    };
};

const getReceiveAssetStarted = () => ({
    type: GET_RECEIVE_ASSET_STARTED
});

export const getReceiveAssetSuccess = serverReport => ({
    type: GET_RECEIVE_ASSET_SUCCESS,
    payload: serverReport
});

export const getReceiveAssetFailure = error => ({
    type: GET_RECEIVE_ASSET_FAILURE,
    payload: error
});


export const getSendAsset = (currency_id, network_id) => {
    let url = host + api.cabinet.getReceiveAsset + `/?currency_id=${currency_id}&network_id=${network_id}`;


    return dispatch => {
        dispatch(getSendAssetStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getSendAssetSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getSendAssetFailure(err));
            });
    };
};

const getSendAssetStarted = () => ({
    type: GET_SEND_ASSET_STARTED
});

export const getSendAssetSuccess = serverReport => ({
    type: GET_SEND_ASSET_SUCCESS,
    payload: serverReport
});

export const getSendAssetFailure = error => ({
    type: GET_SEND_ASSET_FAILURE,
    payload: error
});


export const getSendFee = (currency_id, network_id) => {
    let url = host + api.cabinet.sendFee  + `/?currency_id=${currency_id}&network_id=${network_id}`;


    return dispatch => {
        dispatch(getSendFeeStarted());
        axios.post(url, null, headWT())
            .then(res => {
                dispatch(getSendFeeSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getSendFeeFailure(err));
            });
    };
};

const getSendFeeStarted = () => ({
    type: GET_SEND_FEE_STARTED
});

export const getSendFeeSuccess = serverReport => ({
    type: GET_SEND_FEE_SUCCESS,
    payload: serverReport
});

export const getSendFeeFailure = error => ({
    type: GET_SEND_FEE_FAILURE,
    payload: error
});


export const getMarketCharts = () => {
    let url = host + api.cabinet.marketCharts;


    return dispatch => {
        dispatch(getMarketChartsStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getMarketChartsSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getMarketChartsFailure(err));
            });
    };
};

const getMarketChartsStarted = () => ({
    type: GET_MARKET_CHARTS_STARTED
});

export const getMarketChartsSuccess = serverReport => ({
    type: GET_MARKET_CHARTS_SUCCESS,
    payload: serverReport
});

export const getMarketChartsFailure = error => ({
    type: GET_MARKET_CHARTS_FAILURE,
    payload: error
});


export const getWalletHistory = (direction = "all", page = 1) => {
    let url = host + api.cabinet.wallets + `/transactions`;

    const params = {
        page,
    };

    if (direction && direction !== "all") {
        params.direction = direction;
    }

    const config = {
        ...headWT(),
        params,
    };

    return dispatch => {
        dispatch(getWalletHistoryStarted());

        return axios.get(url, config)
            .then(res => {
                const response = res?.data?.response;

                dispatch(getWalletHistorySuccess(response));

                return response;
            })
            .catch(err => {
                dispatch(getWalletHistoryFailure(err));

                return null;
            });
    };
};

const getWalletHistoryStarted = () => ({
    type: GET_WALLET_HISTORY_STARTED
});

export const getWalletHistorySuccess = serverReport => ({
    type: GET_WALLET_HISTORY_SUCCESS,
    payload: serverReport
});

export const getWalletHistoryFailure = error => ({
    type: GET_WALLET_HISTORY_FAILURE,
    payload: error
});


export const getPartnersMainData = () => {
    let url = host + api.cabinet.partnersMain;


    return dispatch => {
        dispatch(getPartnersMainDataStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getPartnersMainDataSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getPartnersMainDataFailure(err));
            });
    };
};

const getPartnersMainDataStarted = () => ({
    type: GET_PARTNERS_MAIN_DATA_STARTED
});

export const getPartnersMainDataSuccess = serverReport => ({
    type: GET_PARTNERS_MAIN_DATA_SUCCESS,
    payload: serverReport
});

export const getPartnersMainDataFailure = error => ({
    type: GET_PARTNERS_MAIN_DATA_FAILURE,
    payload: error
});


export const getAllPartners = () => {
    let url = host + api.cabinet.partnersAll;


    return dispatch => {
        dispatch(getAllPartnersStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getAllPartnersSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getAllPartnersFailure(err));
            });
    };
};

const getAllPartnersStarted = () => ({
    type: GET_ALL_PARTNERS_STARTED
});

export const getAllPartnersSuccess = serverReport => ({
    type: GET_ALL_PARTNERS_SUCCESS,
    payload: serverReport
});

export const getAllPartnersFailure = error => ({
    type: GET_ALL_PARTNERS_FAILURE,
    payload: error
});


export const exchangePoints = (data, successHandler) => {
    let url = host + api.cabinet.exchangePoints;


    return dispatch => {
        dispatch(exchangePointsStarted());
        axios.post(url, data, headWT())
            .then(res => {
                dispatch(exchangePointsSuccess(res?.data?.response));
                dispatch(getPartnersMainData());
                successHandler();
            })
            .catch(err => {
                dispatch(exchangePointsFailure(err));
            });
    };
};

const exchangePointsStarted = () => ({
    type: EXCHANGE_POINTS_STARTED
});

export const exchangePointsSuccess = serverReport => ({
    type: EXCHANGE_POINTS_SUCCESS,
    payload: serverReport
});

export const exchangePointsFailure = error => ({
    type: EXCHANGE_POINTS_FAILURE,
    payload: error
});


export const getPartnersCard = () => {
    let url = host + api.cabinet.partnersCard;


    return dispatch => {
        dispatch(getPartnersCardStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getPartnersCardSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getPartnersCardFailure(err));
            });
    };
};

const getPartnersCardStarted = () => ({
    type: GET_PARTNERS_CARD_STARTED
});

export const getPartnersCardSuccess = serverReport => ({
    type: GET_PARTNERS_CARD_SUCCESS,
    payload: serverReport
});

export const getPartnersCardFailure = error => ({
    type: GET_PARTNERS_CARD_FAILURE,
    payload: error
});

export const setCabinetPartnersCardEditModalStatus = status => ({
    type: SET_CABINET_PARTNERS_CARD_EDIT_MODAL_STATUS,
    payload: status
});


export const setPartnersCardSettings = (data, successHandler) => {
    let url = host + api.cabinet.partnersCard;


    return dispatch => {
        dispatch(setPartnersCardSettingsStarted());
        axios.put(url, data, headWT())
            .then(res => {
                dispatch(setPartnersCardSettingsSuccess(res?.data?.response));
                dispatch(getPartnersCard());
                successHandler();
            })
            .catch(err => {
                dispatch(setPartnersCardSettingsFailure(err));
            });
    };
};

const setPartnersCardSettingsStarted = () => ({
    type: SET_PARTNERS_CARD_SETTINGS_STARTED
});

export const setPartnersCardSettingsSuccess = serverReport => ({
    type: SET_PARTNERS_CARD_SETTINGS_SUCCESS,
    payload: serverReport
});

export const setPartnersCardSettingsFailure = error => ({
    type: SET_PARTNERS_CARD_SETTINGS_FAILURE,
    payload: error
});


export const setCabinetWalletSubscribeModalStatus = status => ({
    type: SET_CABINET_WALLET_SUBSCRIBE_MODAL_STATUS,
    payload: status
});


export const getSubscribe = () => {
    let url = host + api.cabinet.getSubscribe;


    return dispatch => {
        dispatch(getSubscribeStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getSubscribeSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getSubscribeFailure(err));
            });
    };
};

const getSubscribeStarted = () => ({
    type: GET_SUBSCRIBE_STARTED
});

export const getSubscribeSuccess = serverReport => ({
    type: GET_SUBSCRIBE_SUCCESS,
    payload: serverReport
});

export const getSubscribeFailure = error => ({
    type: GET_SUBSCRIBE_FAILURE,
    payload: error
});


export const setCabinetPartnersPointsHistoryModalStatus = status => ({
    type: SET_CABINET_PARTNERS_POINTS_HISTORY_MODAL_STATUS,
    payload: status
});


export const setCabinetPartnersConvertPointsHistoryModalStatus = status => ({
    type: SET_CABINET_PARTNERS_CONVERT_POINTS_HISTORY_MODAL_STATUS,
    payload: status
});


export const setCabinetProfilePersonalInformationEditModalStatus = status => ({
    type: SET_CABINET_PROFILE_PERSONAL_INFORMATION_EDIT_MODAL_STATUS,
    payload: status
});


export const setProfilePersonalInformation = (data, successHandler) => {
    let url = host + api.cabinet.profilePersonalInfo;


    return dispatch => {
        dispatch(setProfilePersonalInformationStarted());
        axios.put(url, data, headWT())
            .then(res => {
                dispatch(setProfilePersonalInformationSuccess(res?.data?.response));
                dispatch(getProfileMainData());
                dispatch(getUserData());
                successHandler();
            })
            .catch(err => {
                dispatch(setProfilePersonalInformationFailure(err));
            });
    };
};

const setProfilePersonalInformationStarted = () => ({
    type: SET_PROFILE_PERSONAL_INFORMATION_STARTED
});

export const setProfilePersonalInformationSuccess = serverReport => ({
    type: SET_PROFILE_PERSONAL_INFORMATION_SUCCESS,
    payload: serverReport
});

export const setProfilePersonalInformationFailure = error => ({
    type: SET_PROFILE_PERSONAL_INFORMATION_FAILURE,
    payload: error
});


export const getProfileMainData = () => {
    let url = host + api.cabinet.profilePersonalInfo;


    return dispatch => {
        dispatch(getProfileMainDataStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getProfileMainDataSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getProfileMainDataFailure(err));
            });
    };
};

const getProfileMainDataStarted = () => ({
    type: GET_PROFILE_MAIN_DATA_STARTED
});

export const getProfileMainDataSuccess = serverReport => ({
    type: GET_PROFILE_MAIN_DATA_SUCCESS,
    payload: serverReport
});

export const getProfileMainDataFailure = error => ({
    type: GET_PROFILE_MAIN_DATA_FAILURE,
    payload: error
});


export const setCabinetProfileChangePasswordModalStatus = status => ({
    type: SET_CABINET_PROFILE_CHANGE_PASSWORD_MODAL_STATUS,
    payload: status
});


export const profileChangePassword = (data, successHandler) => {
    let url = host + api.cabinet.profileChangePassword;


    return dispatch => {
        dispatch(profileChangePasswordStarted());
        axios.put(url, data, headWT())
            .then(res => {
                dispatch(profileChangePasswordSuccess(res?.data?.response));
                successHandler();
            })
            .catch(err => {
                dispatch(profileChangePasswordFailure(err?.response?.data?.errors));
            });
    };
};

const profileChangePasswordStarted = () => ({
    type: PROFILE_CHANGE_PASSWORD_STARTED
});

export const profileChangePasswordSuccess = serverReport => ({
    type: PROFILE_CHANGE_PASSWORD_SUCCESS,
    payload: serverReport
});

export const profileChangePasswordFailure = error => ({
    type: PROFILE_CHANGE_PASSWORD_FAILURE,
    payload: error
});

export const setCabinetProfileTwoFactorModalStatus = status => ({
    type: SET_CABINET_PROFILE_TWO_FACTOR_MODAL_STATUS,
    payload: status
});


export const getProfile2faOption = () => {
    let url = host + api.cabinet.get2faOptions;


    return dispatch => {
        dispatch(getProfile2faOptionStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getProfile2faOptionSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getProfile2faOptionFailure(err));
            });
    };
};

const getProfile2faOptionStarted = () => ({
    type: GET_PROFILE_OPTION_2FA_STARTED
});

export const getProfile2faOptionSuccess = serverReport => ({
    type: GET_PROFILE_OPTION_2FA_SUCCESS,
    payload: serverReport
});

export const getProfile2faOptionFailure = error => ({
    type: GET_PROFILE_OPTION_2FA_FAILURE,
    payload: error
});


export const setProfile2faOption = (data, successHandler) => {
    let url = host + api.cabinet.get2faOptions;

    return dispatch => {
        dispatch(setProfile2faOptionStarted());

        return axios.post(url, data, headWT())
            .then(res => {
                const response = res?.data?.response;

                dispatch(setProfile2faOptionSuccess(response));

                if (successHandler) {
                    successHandler(response);
                }

                return response;
            })
            .catch(err => {
                dispatch(setProfile2faOptionFailure(err));

                return null;
            });
    };
};

const setProfile2faOptionStarted = () => ({
    type: SET_PROFILE_OPTION_2FA_STARTED
});

export const setProfile2faOptionSuccess = serverReport => ({
    type: SET_PROFILE_OPTION_2FA_SUCCESS,
    payload: serverReport
});

export const setProfile2faOptionFailure = error => ({
    type: SET_PROFILE_OPTION_2FA_FAILURE,
    payload: error
});

export const setProfile2faGoogleCode = (data, successHandler) => {
    let url = host + api.cabinet.set2faGoogleCode;

    return dispatch => {
        dispatch(setProfile2faGoogleCodeStarted());

        return axios.post(url, data, headWT())
            .then(res => {
                const response = res?.data?.response;

                dispatch(setProfile2faGoogleCodeSuccess(response));

                if (successHandler) {
                    successHandler(response);
                }

                return response;
            })
            .catch(err => {
                dispatch(setProfile2faGoogleCodeFailure(err));

                return null;
            });
    };
};

const setProfile2faGoogleCodeStarted = () => ({
    type: SET_GOOGLE_CODE_2FA_STARTED
});

export const setProfile2faGoogleCodeSuccess = serverReport => ({
    type: SET_GOOGLE_CODE_2FA_SUCCESS,
    payload: serverReport
});

export const setProfile2faGoogleCodeFailure = error => ({
    type: SET_GOOGLE_CODE_2FA_FAILURE,
    payload: error
});


export const set2faSettings = (data, successHandler) => {
    let url = host + api.cabinet.set2faSettings;

    return dispatch => {
        dispatch(set2faSettingsStarted());

        return axios.put(url, data, headWT())
            .then(res => {
                const response = res?.data?.response;

                dispatch(set2faSettingsSuccess(response));

                if (successHandler) {
                    successHandler(response);
                }

                return response;
            })
            .catch(err => {
                dispatch(set2faSettingsFailure(err));

                return null;
            });
    };
};

const set2faSettingsStarted = () => ({
    type: SET_2FA_SETTINGS_STARTED
});

export const set2faSettingsSuccess = serverReport => ({
    type: SET_2FA_SETTINGS_SUCCESS,
    payload: serverReport
});

export const set2faSettingsFailure = error => ({
    type: SET_2FA_SETTINGS_FAILURE,
    payload: error
});


export const setCabinetDepositOpenModalStatus = status => ({
    type: SET_CABINET_DEPOSIT_OPEN_MODAL_STATUS,
    payload: status
});


export const getDepositAll = () => {
    let url = host + api.cabinet.depositAll;


    return dispatch => {
        dispatch(getDepositAllStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getDepositAllSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getDepositAllFailure(err));
            });
    };
};

const getDepositAllStarted = () => ({
    type: GET_DEPOSIT_ALL_STARTED
});

export const getDepositAllSuccess = serverReport => ({
    type: GET_DEPOSIT_ALL_SUCCESS,
    payload: serverReport
});

export const getDepositAllFailure = error => ({
    type: GET_DEPOSIT_ALL_FAILURE,
    payload: error
});


export const getDepositCurrency = () => {
    let url = host + api.cabinet.getCurrency;


    return dispatch => {
        dispatch(getDepositCurrencyStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getDepositCurrencySuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getDepositCurrencyFailure(err));
            });
    };
};

const getDepositCurrencyStarted = () => ({
    type: GET_DEPOSIT_CURRENCY_STARTED
});

export const getDepositCurrencySuccess = serverReport => ({
    type: GET_DEPOSIT_CURRENCY_SUCCESS,
    payload: serverReport
});

export const getDepositCurrencyFailure = error => ({
    type: GET_DEPOSIT_CURRENCY_FAILURE,
    payload: error
});


export const getDepositNetwork = (id) => {
    let url = host + api.cabinet.getCurrency + `/${id}/networks`;


    return dispatch => {
        dispatch(getDepositNetworkStarted(id));
        axios.get(url, headWT())
            .then(res => {
                dispatch(getDepositNetworkSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getDepositNetworkFailure(err));
            });
    };
};

const getDepositNetworkStarted = currencyId => ({
    type: GET_DEPOSIT_NETWORK_STARTED,
    payload: currencyId
});

export const getDepositNetworkSuccess = serverReport => ({
    type: GET_DEPOSIT_NETWORK_SUCCESS,
    payload: serverReport
});

export const getDepositNetworkFailure = error => ({
    type: GET_DEPOSIT_NETWORK_FAILURE,
    payload: error
});


export const getDepositAsset = (currency_id, network_id) => {
    let url = host + api.cabinet.getReceiveAsset + `/?currency_id=${currency_id}&network_id=${network_id}`;


    return dispatch => {
        dispatch(getDepositAssetStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getDepositAssetSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getDepositAssetFailure(err));
            });
    };
};

const getDepositAssetStarted = () => ({
    type: GET_DEPOSIT_ASSET_STARTED
});

export const getDepositAssetSuccess = serverReport => ({
    type: GET_DEPOSIT_ASSET_SUCCESS,
    payload: serverReport
});

export const getDepositAssetFailure = error => ({
    type: GET_DEPOSIT_ASSET_FAILURE,
    payload: error
});


export const setCabinetProfileDisableTwoFactorModalStatus = status => ({
    type: SET_CABINET_PROFILE_DISABLE_2FA_MODAL_STATUS,
    payload: status
});


export const disable2fa = (data, successHandler) => {
    let url = host + api.cabinet.get2faOptions;

    return dispatch => {
        dispatch(disable2faStarted());

        return axios.delete(url, {
            ...headWT(),
            data,
        })
            .then(res => {
                const response = res?.data?.response;

                dispatch(disable2faSuccess(response));

                if (successHandler) {
                    successHandler(response);
                }

                return response;
            })
            .catch(err => {
                dispatch(disable2faFailure(err));

                return null;
            });
    };
};

const disable2faStarted = () => ({
    type: DISABLE_2FA_STARTED
});

export const disable2faSuccess = serverReport => ({
    type: DISABLE_2FA_SUCCESS,
    payload: serverReport
});

export const disable2faFailure = error => ({
    type: DISABLE_2FA_FAILURE,
    payload: error
});


export const getDepositFee = (currency_id, network_id) => {
    let url = host + api.cabinet.sendFee + `/?currency_id=${currency_id}&network_id=${network_id}`;

    return dispatch => {
        dispatch(getDepositFeeStarted());

        axios.post(url, null, headWT())
            .then(res => {
                dispatch(getDepositFeeSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getDepositFeeFailure(err));
            });
    };
};

const getDepositFeeStarted = () => ({
    type: GET_DEPOSIT_FEE_STARTED
});

export const getDepositFeeSuccess = serverReport => ({
    type: GET_DEPOSIT_FEE_SUCCESS,
    payload: serverReport
});

export const getDepositFeeFailure = error => ({
    type: GET_DEPOSIT_FEE_FAILURE,
    payload: error
});


export const openDeposit = (data, successHandler) => {
    let url = host + api.cabinet.openDeposit;

    return dispatch => {
        dispatch(openDepositStarted());

        return axios.post(url, data, headWT())
            .then(res => {
                const response = res?.data?.response;

                dispatch(openDepositSuccess(response));

                if (successHandler) {
                    successHandler(response);
                }

                return response;
            })
            .catch(err => {
                dispatch(openDepositFailure(err));

                return null;
            });
    };
};

const openDepositStarted = () => ({
    type: OPEN_DEPOSIT_STARTED
});

export const openDepositSuccess = serverReport => ({
    type: OPEN_DEPOSIT_SUCCESS,
    payload: serverReport
});

export const openDepositFailure = error => ({
    type: OPEN_DEPOSIT_FAILURE,
    payload: error
});


export const getTwoFactorOptions = () => {
    let url = host + api.cabinet.get2faOptions;

    return dispatch => {
        dispatch(getTwoFactorOptionsStarted());

        return axios.get(url, headWT())
            .then(res => {
                const response = res?.data?.response;

                dispatch(getTwoFactorOptionsSuccess(response));

                return response;
            })
            .catch(err => {
                dispatch(getTwoFactorOptionsFailure(err));

                return null;
            });
    };
};

const getTwoFactorOptionsStarted = () => ({
    type: GET_TWO_FACTOR_OPTIONS_STARTED
});

export const getTwoFactorOptionsSuccess = serverReport => ({
    type: GET_TWO_FACTOR_OPTIONS_SUCCESS,
    payload: serverReport
});

export const getTwoFactorOptionsFailure = error => ({
    type: GET_TWO_FACTOR_OPTIONS_FAILURE,
    payload: error
});


export const sendCrypto = (data, successHandler) => {
    let url = host + api.cabinet.sendCrypto;

    return dispatch => {
        dispatch(sendCryptoStarted());

        return axios.post(url, data, headWT())
            .then(res => {
                const response = res?.data?.response;

                dispatch(sendCryptoSuccess(response));
                dispatch(refreshWalletHistory());

                if (successHandler) {
                    successHandler(response);
                }

                return response;
            })
            .catch(err => {
                dispatch(sendCryptoFailure(err));

                return null;
            });
    };
};

const sendCryptoStarted = () => ({
    type: SEND_CRYPTO_STARTED
});

export const sendCryptoSuccess = serverReport => ({
    type: SEND_CRYPTO_SUCCESS,
    payload: serverReport
});

export const sendCryptoFailure = error => ({
    type: SEND_CRYPTO_FAILURE,
    payload: error
});


export const updateUserAvatar = (data, successHandler) => {
    let url = host + api.cabinet.avatar;

    const formData = new FormData();
    formData.append('avatar', data.avatar);

    return dispatch => {
        dispatch(updateUserAvatarStarted());

        const config = headWT();

        return axios.post(url, formData, {
            ...config,
            headers: {
                ...(config.headers || {}),
                'Content-Type': 'multipart/form-data',
            },
        })
            .then(res => {
                const response = res?.data?.response;

                dispatch(updateUserAvatarSuccess(response));

                if (successHandler) {
                    successHandler(response);
                }

                return response;
            })
            .catch(err => {
                dispatch(updateUserAvatarFailure(err));

                return null;
            });
    };
};

const updateUserAvatarStarted = () => ({
    type: UPDATE_USER_AVATAR_STARTED
});

export const updateUserAvatarSuccess = serverReport => ({
    type: UPDATE_USER_AVATAR_SUCCESS,
    payload: serverReport
});

export const updateUserAvatarFailure = error => ({
    type: UPDATE_USER_AVATAR_FAILURE,
    payload: error
});


export const getPartnersConvertHistory = (page = 1) => {
    let url = host + api.cabinet.partnersConvertHistory + `?per_page=10&page=${page}`;

    return dispatch => {
        dispatch(getPartnersConvertHistoryStarted());

        axios.get(url, headWT())
            .then(res => {
                dispatch(getPartnersConvertHistorySuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getPartnersConvertHistoryFailure(err));
            });
    };
};

const getPartnersConvertHistoryStarted = () => ({
    type: GET_PARTNERS_CONVERT_HISTORY_STARTED
});

export const getPartnersConvertHistorySuccess = serverReport => ({
    type: GET_PARTNERS_CONVERT_HISTORY_SUCCESS,
    payload: serverReport
});

export const getPartnersConvertHistoryFailure = error => ({
    type: GET_PARTNERS_CONVERT_HISTORY_FAILURE,
    payload: error
});


export const hideBalance = (data, successHandler) => {
    let url = host + api.cabinet.hideBalance;

    return dispatch => {
        dispatch(hideBalanceStarted());

        return axios.put(url, data, headWT())
            .then(res => {
                const response = res?.data?.response;

                dispatch(hideBalanceSuccess(response));

                if (successHandler) {
                    successHandler(response);
                }

                return response;
            })
            .catch(err => {
                dispatch(hideBalanceFailure(err));

                return null;
            });
    };
};

const hideBalanceStarted = () => ({
    type: HIDE_BALANCE_STARTED
});

export const hideBalanceSuccess = serverReport => ({
    type: HIDE_BALANCE_SUCCESS,
    payload: serverReport
});

export const hideBalanceFailure = error => ({
    type: HIDE_BALANCE_FAILURE,
    payload: error
});


